
















import Vue from 'vue';
import { IOrg } from '@/store/types';
import AdminService from '@/api/admin.service';
import * as mutations from '@/store/mutation-types';
import { SWITCH_ORG } from '@/store/action-types';

export default Vue.extend({
  data() {
    return {
      loading: false,
    };
  },
  async created() {
    const orgs = await AdminService.listOrgs();
    this.$store.commit(mutations.SET_ORGS, orgs);
    this.loading = false;
  },
  computed: {
    orgs(): IOrg[] {
      return this.$store.state.orgs;
    },
    selectedOrg() {
      return this.$store.state.asOrg;
    },
    selectedOrgName(): string {
      return this.orgs.find((d) => d._id === this.selectedOrg)?.name || this.selectedOrg;
    },
  },
  methods: {
    selectOrg(value: string | null | undefined) {
      this.$store.commit(mutations.ADMIN_CLEAR_STATE);
      this.$store.dispatch(SWITCH_ORG, value || null);
    },
  },
});
